import { useState } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import moment from "moment";

const ExportForm = (props) => {
  const [isLoading, setLoading] = useState(false);
  const [minDateValue, setMinDate] = useState('');

  const handleSubmit = async (event) => {
      event.preventDefault();
      setLoading(true);
      let reqData = {
        campaignStart: moment(event.target[0].value).format("ll"),
        campaignEnd: moment(event.target[1].value).format("ll")
      };
      props.sendData(reqData);
      handleClose();
      setLoading(false);
    },
    handleClose = () => {
      setMinDate('');
      props.setShow(false);
    },
    onDateChange = (event) => {
      setMinDate(event.target.value);
    };

  return (
    <Modal show={props.show} onHide={handleClose} backdrop='static' keyboard={false}>
      <Modal.Header closeButton closeLabel='' style={{ borderRadius: 5 }}>
        <Modal.Title>Campaign Start Date Range</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className='mb-3' controlId='campaignStart'>
            <Form.Label>Start Date</Form.Label>
            <Form.Control
              required
              type='date'
              name='campaignStart'
              onChange={onDateChange}
              defaultValue={props.startDate ? props.startDate.toString().substring(0, 10) : null}
            />
          </Form.Group>
          <Form.Group className='mb-3' controlId='campaignEnd'>
            <Form.Label>End Date</Form.Label>
            <Form.Control
              required
              type='date'
              name='campaignEnd'
              min={minDateValue !== '' ? minDateValue : props.startDate ? props.startDate.toString().substring(0, 10) : null}
              defaultValue={props.endDate ? props.endDate.toString().substring(0, 10) : null}
            />
          </Form.Group>
          <Button variant='primary' type='submit'>
            Export
          </Button>
        </Form>
      </Modal.Body>
      {isLoading && (
        <div
          style={{
            position: 'absolute',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            zIndex: 999,
            backgroundColor: '#000000c4',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
          <Spinner animation='border' variant='primary' />
        </div>
      )}
    </Modal>
  );
};

export default ExportForm;
